// src/components/ItemListSchema.jsx
import React from "react";
import { Helmet } from "react-helmet";

const ItemListSchema = ({ investors, countryName }) => {
  // Gracefully skip execution if no investor data arrays are passed
  if (!investors || investors.length === 0) return null;

  const normalizedCountry = countryName || "Regional";

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": `Verified Startup Investors Directory - ${normalizedCountry}`,
    "description": `Directory of active angel investors and venture capital firms in ${normalizedCountry}.`,
    "numberOfItems": investors.length,
    "itemListElement": investors.map((investor, idx) => {
      // Build absolute canonical URL targeting the specific profile page routing path
      const targetProfileUrl = investor.profileSlug 
        ? `https://investorlanes.com${investor.profileSlug}`
        : `https://investorlanes.com`;

      return {
        "@type": "ListItem",
        "position": idx + 1,
        "item": {
          "@type": investor.type === "Angel Investor" ? "Person" : "Organization",
          "name": investor.name,
          "url": targetProfileUrl, // FIXED: Absolute URL target provided to secure GSC index validation
          "image": investor.photoURL 
            ? `https://investorlanes.com${investor.photoURL}` 
            : "https://investorlanes.com"
        }
      };
    })
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ItemListSchema;
